import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import { IconArrowUp } from '../../../assests/icons'

import './style.scss'

const ExpandableHeader = props => {
  const {
    children,
    headerIcon,
    expanded,
    eventKey
  } = props

  const [isExpanded, setIsExpanded] = useState(expanded)
  const decoratedOnClick = useAccordionButton(eventKey)

  return (
    <div className="expandable-header">
      {headerIcon && <span className="header-icon">{headerIcon}</span>}
      {children}
      <span
        role="button"
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          setIsExpanded(!isExpanded)
          decoratedOnClick(e)
        }}
        className={cn('toggle-button', { expanded: isExpanded })}
      >
        <IconArrowUp />
      </span>
    </div>
  )
}

ExpandableHeader.propTypes = {
  children: PropTypes.node,
  headerIcon: PropTypes.node,
  expanded: PropTypes.bool,
  onClick: PropTypes.func
}

ExpandableHeader.defaultProps = {
  expanded: true,
}

export default ExpandableHeader
